// this is the single instance of i18n to be shared across the app
// it will be initialized in the useI18n hook that's called in the root component
import i18n from 'i18next';
export default i18n;